import React from 'react';
import IconName from "../../svgLogo/SvgLogo";

const Chart = () => {
    return (
        <div className="chart-product">
            <div className="container">
                <div className="title xmb-6 d-block d-lg-none">
                    <div className="title-box just-text title-box-blue">
                        <div className="title-bg">
                            <h2 className="text">
                                نمودار قیمت
                            </h2>
                        </div>
                    </div>
                </div>
                <div className="chart-box">
                    <div className="filter-chart position-relative xmb-6">
                        <select className="category-select ct-lg form-select">
                            <option value="1">آیفون 11 </option>
                            <option value="2">سامسونگ</option>
                            <option value="3">شیائومی</option>
                            <option value="4">نوکیا1</option>
                        </select>
                        <IconName name="expand_more" className="icon position-absolute more-icon"/>
                    </div>
                    <canvas id="chart-product"/>
                </div>
            </div>
        </div>
    );
};

export default Chart;
